export const PUBLIC_ZONE = "webokna.online";
export const HIDDEN_ZONE = "itokna.online";
export const INSTANCE_ZONES = [PUBLIC_ZONE, HIDDEN_ZONE];

export function currentHost() {
  if (typeof window === "undefined") return "";
  return window.location.hostname.replace(/^www\./i, "").toLowerCase();
}

export function currentSiteDomain(allowed = INSTANCE_ZONES) {
  const domains = allowed?.length ? allowed : INSTANCE_ZONES;
  const host = currentHost();
  if (domains.includes(host)) return host;
  return domains[0];
}

export function instanceUrls(name, zones = INSTANCE_ZONES) {
  if (!name) return [];
  return zones.map((zone) => `https://${name}.${zone}`);
}

export function pickSiteUrl(urls, fallback) {
  const list = urls?.length ? urls : fallback ? [fallback] : [];
  const site = currentSiteDomain();
  return list.find((item) => item.includes(`.${site}`)) || list[0] || fallback || "";
}

/** Hide the undocumented alias unless the cabinet is already open on that zone. */
export function visibleInstanceUrls(urls) {
  const list = (urls || []).filter(Boolean);
  const site = currentSiteDomain();
  if (site === HIDDEN_ZONE) {
    return list.filter((url) => url.includes(HIDDEN_ZONE));
  }
  return list.filter((url) => !url.includes(HIDDEN_ZONE));
}

export function toPublicHost(value) {
  if (!value) return value;
  if (currentSiteDomain() === HIDDEN_ZONE) return value;
  return String(value).replaceAll(HIDDEN_ZONE, PUBLIC_ZONE);
}
